<template>
  <div id="app" ref="app">
    <pagesTop @changeLange="changeLange" :screenWidth="screenWidth" :menu="menu" :language="language"
      :screenHeight="screenHeight" :bannerLists="bannerLists" :isLoop="isLoop" @scrollBottom="scrollBottom" :config="config"></pagesTop>
    <div style="min-height: 100vh;max-width: 100vw;height: 100%">
      <transition name="fade-transform" mode="out-in">
        <router-view :key="key" />
      </transition>
    </div>
    <pagesBottom :config="config" :language="language"></pagesBottom>
  </div>
</template>

<script>
import store from './store'
import pagesTop from './components/pagesTop.vue'
import pagesBottom from './components/pagesBottom.vue'
import {
  getMenu,
  getConfig,
  bannerList
} from '@/api/index.js'

import { mapState } from 'vuex';
export default {
  name: 'App',
  components: {
    pagesTop,
    pagesBottom
  },
  data() {
    return {
      language: localStorage.getItem("locale") || "zh",//当前语言
      screenWidth: 0,
      screenHeight: 0,
      menu: [],//菜单
      config: null,//配置
      bannerLists: [],
      isLoop: true,
    }
  },
  computed: {
    key() {
      if (this.$route.fullPath == '/' && window.location.hash != '#/') {
        return window.location.hash
      } else {
        return window.location.hash
      }
    },
    isLogo() {
      let routes = this.$router.options.routes, url = ''
      const path = this.$route.path
      for (let i = 0; i < routes.length; i++) {
        if (routes[i].path == path) {
          url = routes[i].path
          break
        }
        if (routes[i].children && routes[i].children.length > 0) {
          for (let k = 0; k < routes[i].children.length; k++) {
            if (routes[i].children[k].path == path) {
              url = routes[i].path
              break
            }
          }
        }

      }
      const data = url == '/mine' ? false : true
      return data
    }
  },
  created() {
    let path = window.location.hash
    if (path == '#/') {
      store.commit('changeOneIndex', 0)
      store.commit('changeTwoIndex', -1)
      localStorage.setItem('choiceOne', 0) //缓存当前选择1级菜单的index
      localStorage.setItem('choiceTwo', -1) //缓存当前选择2级菜单的index
    } else {
      let one = localStorage.getItem('choiceOne')
      let two = localStorage.getItem('choiceTwo')
      store.commit('changeOneIndex', one)
      store.commit('changeTwoIndex', two)
    }
    let data = localStorage.getItem("locale") || "zh"
    store.commit('changeLanguage', data)
    this.getBanner()
    this.getMenu();
    this.getConfig();
    this.getScreenSize();
    window.addEventListener('resize', this.getScreenSize);
  },
  beforeDestroy() {
    // 销毁前清除缓存的一级二级选中id和二级菜单
    localStorage.removeItem('choiceOne')
    localStorage.removeItem('getTwoMenu')
    localStorage.removeItem('choiceTwo')
  },
  destroyed() {
    window.removeEventListener('resize', this.getScreenSize);
  },
  methods: {
    // 滑动到底部
    scrollBottom() {
      const container = this.$refs.app;
      let height = container.scrollHeight
      window.scrollTo({
        top: height,
        behavior: 'smooth'
      });
    },
    // 中英文切换
    changeLange() {
      if (this.language == 'zh') {
        this.$i18n.locale = 'en'
        this.language = "en"
        localStorage.setItem("locale", "en");
        store.commit('changeLanguage', 'en')
      } else if (this.language == 'en') {
        this.$i18n.locale = 'zh'
        this.language = "zh"
        localStorage.setItem("locale", "zh");
        store.commit('changeLanguage', 'zh')
        // location.reload(); //重新加载
      }
      this.getBanner()
      // 修改网站peizhi
      this.updata()
      // 修改网站peizhiend
    },
    // 获取当前屏幕宽高
    getScreenSize() {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
      // this.getBanner()
    },
    // 获取网站菜单
    async getMenu() {
      let that = this
      const info = await getMenu()
      if (info && info.code == 200) {
        that.menu = [{
          id: 0,
          columnType: 0,
          isHidden: 0,
          childList: [],
          typename: '首页',
          enTypename: 'Home'
        }, ...info.data]
        store.commit('getMenuList', that.menu)
      }
    },
    // 获取网站配置
    async getConfig() {
      let that = this
      const info = await getConfig()
      if (info && info.code == 200) {
        that.config = info.data
        store.commit('getConfig', info.data)
        that.updata()
      }
    },
    // 修改网也配置
    updata() {
      // 更新favicon
      if (this.config && this.config.icon) {
        const favicon = document.querySelector('link[rel="icon"]');
        favicon.href = this.config.icon;
      }
      // 修改网站标题
      store.commit('getTitle')
      if (store.state.name) {
        document.title = store.state.name
      }
      // 修改网站描述
      if (store.state.describe) {
        const meta = document.querySelector('meta[name="description"]');
        if (meta) {
          meta.setAttribute('content', store.state.describe);
        } else {
          // 如果不存在，则创建一个新的meta标签
          const newMeta = document.createElement('meta');
          newMeta.setAttribute('name', 'description');
          newMeta.setAttribute('content', store.state.describe);
          document.head.appendChild(newMeta);
        }
      }

      // 修改网站关键字
      if (store.state.keyWords) {
        const metaKey = document.querySelector('meta[name="keywords"]');
        if (metaKey) {
          metaKey.setAttribute('content', store.state.keyWords);
        } else {
          const newMeta = document.createElement('meta');
          newMeta.setAttribute('name', 'keywords');
          newMeta.setAttribute('content', store.state.keyWords);
          document.head.appendChild(newMeta);
        }
      }
      //  end
    },
    // 获取首页banner
    // getBanner() {
    //   if (!this.config) return
    //   if (this.language == 'zh' && this.screenWidth < 1200) { //手机版banner
    //     this.bannerLists = this.config.mobileBanner.split(',')
    //   } else if (this.language == 'zh' && (this.screenWidth >= 1200)) { //pc版banner
    //     this.bannerLists = this.config.banner.split(',')
    //   } else if (this.language == 'en' && this.screenWidth < 1200) { //手机版英文banner
    //     this.bannerLists = this.config.enMobileBanner.split(',')
    //   } else {//pc版英文banner
    //     this.bannerLists = this.config.enBanner.split(',')
    //   }
    // },
    // 2024-10-21 获取banner列表
    async getBanner() {
      let data = {
        position: 1,
        lang: this.language == 'zh' ? 'cn' : 'en'
      }
      const info = await bannerList(data)
      if (info && info.code == 200) {
        this.bannerLists = info.data
        if (this.bannerLists.length <= 1) {
          this.isLoop = false
        } else {
          this.isLoop = true
        }
      }
    },
  }
}
</script>

<style>
#app {
  width: 100%;
  min-height: 100vh;
}
.fontSize40{
  font-size: 40px;
}

.fontSize20{
  font-size: 20px;
}

.fontSize16{
  font-size: 16px;
}

.fontSize14{
  font-size: 14px;
}

.lineHeight16{
  line-height: 16px;
}

.lineHeight18{
  line-height: 18px;
}

.fontSize12{
  font-size: 12px;
}
</style>
